import { Grid, Typography } from "@mui/material";
import {
  MaterialReactTable,
  MRT_ColumnDef,
  useMaterialReactTable,
} from "material-react-table";
import React, { useMemo } from "react";
import { ClientContact } from "../../../app/models/responseModels/clientsResponse";
import { getDefaultMRTOptions } from "../../dedicatedDelivery/DefaultMrtOptions";

interface ClientContactGridProps {
  data: ClientContact[];
}

const ClientContactGrid: React.FC<ClientContactGridProps> = ({ data }) => {
  const defaultMRTOptions = getDefaultMRTOptions<ClientContact>();

  // Columns to be used on grid on landing page
  const columns = useMemo<MRT_ColumnDef<ClientContact>[]>(
    () => [
      {
        accessorKey: "id",
        header: "ID",
      },
      {
        accessorKey: "contactName",
        header: "Name",
      },
      {
        accessorKey: "email",
        header: "Email",
      },
      {
        accessorKey: "phoneNumber",
        header: "Phone Number",
      },
      {
        accessorKey: "createdOn",
        header: "Created On",
        size: 10,
        Cell: ({ cell, row }) => (
          <div>
            {row.original.createdOn ? (
              <span>
                {new Date(cell.getValue<string>()).toLocaleString("en-US", {
                  hourCycle: "h12",
                })}
              </span>
            ) : (
              <span></span>
            )}
          </div>
        ),
      },
      {
        accessorKey: "updatedOn",
        header: "Updated On",
        size: 10,
        Cell: ({ cell, row }) => (
          <div>
            {row.original.createdOn ? (
              <span>
                {new Date(cell.getValue<string>()).toLocaleString("en-US", {
                  hourCycle: "h12",
                })}
              </span>
            ) : (
              <span></span>
            )}
          </div>
        ),
      },
    ],
    []
  );

  // preprare MRT V2 grid
  const table = useMaterialReactTable({
    ...defaultMRTOptions,
    columns: columns,
    data: data,
    initialState: {
      ...defaultMRTOptions.initialState,
      columnVisibility: {
        id: true,
      },
      sorting: [{ desc: true, id: "id" }],
    },
    state: {
      showProgressBars: false,
      sorting: [{ desc: true, id: "id" }],
    },
    muiTableBodyRowProps: ({ row }) => ({
      onClick: (e) => {},
      ...defaultMRTOptions.muiTableBodyRowProps,
      sx: {
        cursor: "pointer",
      },
    }),
    renderTopToolbarCustomActions: ({ table }) => <></>,
    renderBottomToolbarCustomActions: () => {
      return (
        <Typography variant="subtitle2" component="p">
          Total Rows: {data.length}
        </Typography>
      );
    },
  });
  return (
    <Grid item xs={12} sm={12} md={12} lg={12}>
      <MaterialReactTable table={table} />
    </Grid>
  );
};

export default ClientContactGrid;
